import ServicePageLayout from "../services/ServicePageLayout";
import { CITIES } from "../../lib/cities";

export default function CityPage({ cityKey }) {
  const city = CITIES[cityKey];
  if (!city) return null;

  return (
    <ServicePageLayout
      slug={city.slug}
      title={`Paysagiste à ${city.name} — Création, entretien & anti-nuisibles`}
      seoTitle={city.seoTitle}
      seoDescription={city.seoDescription}
      badge={`📍 ${city.name} · ${city.department} · ${city.distance}`}
      hero={`K'REUSE EXTÉRIEUR intervient à ${city.name} et ses environs pour tous vos projets d'extérieur : création et entretien de jardin, élagage, abattage et lutte contre les nuisibles.`}
      intro={city.description}
      bullets={[
        "Création de jardin sur-mesure",
        "Entretien régulier (crédit d'impôt 50%)",
        "Tonte de pelouse et taille de haies",
        "Élagage et abattage d'arbres",
        "Destruction nids de frelons et guêpes",
        `Communes voisines : ${city.nearby.join(", ")}`,
      ]}
      process={[
        { title: "Premier contact", desc: `Appel ou message depuis ${city.name}, écoute de votre besoin.` },
        { title: "Devis sur place", desc: "Visite gratuite, étude du terrain, proposition claire." },
        { title: "Intervention", desc: "Travail soigné, ponctuel et respect des délais." },
      ]}
      ctaTitle={`Un projet à ${city.name} ?`}
      ctaDesc="Devis gratuit, intervention rapide en Creuse."
      image={city.image}
      whatsappText={`Bonjour, je suis à ${city.name} et je souhaite un devis K'REUSE EXTÉRIEUR.`}
    />
  );
}
